/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Constants" />
export class TestPlansLibraryConstants {
    public static TestCaseTabId = "testcases";
    public static NewTestCaseButtonId = "new-testcase";
    public static ImportButtonId = "import";
    public static ExportButtonId = "export";
    public static ColumnOptionsButtonId = "column-options";
    public static MaxTagsInACell = 2; 
    public static TestCaseWorkItemType = "Test Case";
    public static BackButton = "BackButton";
}

export class TelemetryConstants {
    public static TEST_HUB_FEATURE_AREA_NAME = "TestManagement";
    public static TESTCASES_PIVOT_PAGE_LOAD_TTI_SCENARIO = "TestPlansLibraryTestCasesPivotTTI";
}

export class WorkItemConstants {
    public static WitStateField = "System.State";
    public static WitTagsField = "System.Tags";
    public static WitAreaPathField = "System.AreaPath";
    public static WitAssignedToField = "System.AssignedTo";
    public static WitIdField = "System.Id";
    public static WorkItemCreateMode = "create";
    public static WorkItemEditMode = "edit";
}

export class LibraryWorkItemDataProviderConstants {
    public static LibraryQueryType = "libraryQueryType";
    public static ContinuationToken = "continuationToken";
    public static OrderByField = "orderByField";
}

export class LibraryQueryConstants {
    public static QueryAllTestCasesKey = "all-test-cases";
    public static QueryTestsWithActiveBugsKey = "test-cases-with-active-bugs";
    public static QueryTestsWithoutRequirementsKey = "test-cases-without-requirements";
    public static QueryTestsWithRequirementsKey = "test-cases-with-requirements";
}
